/* This file was generated automatically. Do not edit manually. */

export enum PaymentCardType {
    MasterCard = 'MasterCard',
    Visa = 'Visa',
    Amex = 'Amex',
    Discover = 'Discover',
    DinersClub = 'DinersClub',
    Jcb = 'Jcb',
    Maestro = 'Maestro',
    UnionPay = 'UnionPay',
    VPay = 'VPay',
    RuPay = 'RuPay',
    Dankort = 'Dankort',
    Mir = 'Mir',
    Verve = 'Verve',
    Troy = 'Troy',
    PostFinance = 'PostFinance',
    Giro = 'Giro',
    Bancomat = 'Bancomat',
    Bc = 'Bc',
    CarteBleue = 'CarteBleue',
    Eftpos = 'Eftpos',
    Eps = 'Eps',
    Interac = 'Interac',
    Isracard = 'Isracard',
    Meps = 'Meps',
    Nets = 'Nets',
    Bancontact = 'Bancontact',
}
